import { render, staticRenderFns } from "./ThumbnailGallerySwiper.vue?vue&type=template&id=370e63f1&scoped=true&"
import script from "./ThumbnailGallerySwiper.vue?vue&type=script&lang=js&"
export * from "./ThumbnailGallerySwiper.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailGallerySwiper.vue?vue&type=style&index=0&id=370e63f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370e63f1",
  null
  
)

export default component.exports